import React from 'react';
import { FaDiscord } from 'react-icons/fa';
import { SiKofi } from 'react-icons/si';
import styled from 'styled-components';

const SocialContainer = styled.div`
  position: fixed;
  right: 20px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;

  @media (max-width: 768px) {
    left: 10px;
    right: auto;
    bottom: 70px;
    transform: scale(0.9);
  }

  @media (max-width: 480px) {
    transform: scale(0.8);
    gap: 8px;
  }
`;

const SocialButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border-radius: 8px;
  text-decoration: none;
  color: white;
  font-weight: 600;
  transition: transform 0.2s, opacity 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(5px);
  background-color: ${props => props.bgcolor}dd; /* Added transparency */

  &:hover {
    transform: translateY(-2px);
    opacity: 0.9;
  }

  svg {
    margin-right: 8px;
    font-size: 1.2em;
  }

  @media (max-width: 480px) {
    padding: 8px 12px;
    font-size: 0.9em;
    
    svg {
      font-size: 1.1em;
    }
  }
`;

const DiscordButton = styled(SocialButton).attrs({
  bgcolor: '#5865F2'
})``;

const KofiButton = styled(SocialButton).attrs({
  bgcolor: '#FF5E5B'
})``;

const SocialSupport = () => {
  return (
    <SocialContainer>
      <DiscordButton 
        href="https://discord.gg/Qa5Qe4eJeH" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <FaDiscord /> Join Discord
      </DiscordButton>
      <KofiButton 
        href="https://ko-fi.com/pokecomp" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <SiKofi /> Support Us
      </KofiButton>
    </SocialContainer>
  );
};

export default SocialSupport; 